import { __awaiter } from "tslib";
import axios from 'axios';
/**
 * Function to replace graphql-request, basically lifted from https://the-guild.dev/graphql/codegen/docs/guides/react-query#type-safe-graphql-operation-execution
 */
export function gqlrequest(graphqlUrl, query, headers, ...[variables]) {
    return __awaiter(this, void 0, void 0, function* () {
        headers.Accept = 'application/graphql-response+json';
        const reqBody = JSON.stringify({
            query,
            variables,
        });
        const axiosConfig = {
            headers: headers,
        };
        const response = yield axios.post(graphqlUrl, reqBody, axiosConfig);
        if (response.status !== 200) {
            throw new Error(`Unable to communicate with endpoint ${graphqlUrl}.  ${response.statusText}`);
        }
        return response.data;
    });
}
